import { Logger } from '~/helpers/logger';
import { VsfContext } from '~/composables/context';
import DOMPurify from 'isomorphic-dompurify';
import { map } from "lodash-es";

export const loadBlocksCommand = {
  execute: async (context: VsfContext, params) => {
    const identifiers = map(params.identifiers, (item) => DOMPurify.sanitize(item));

    Logger.debug('[Magento]: Load CMS Blocks content', { params });
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const { data } = await context.$magento.api.cmsBlocks(identifiers, params.customQuery ?? null, params?.customHeaders);

    Logger.debug('[Result]:', { data });

    return data.cmsBlocks.items;
  },
};
